function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMyHomepageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 12.695974,35.130548 c 0.02802,1.564009 0.01428,52.865411 0.01428,52.865411 0.77529,3.283439 3.053176,5.270525 6.30334,5.430909 l 62.172675,0.0062 c 3.495584,-0.52045 5.517961,-2.573034 6.067267,-6.157613 l 0.05049,-51.778948",
    style: {
      fill: "none",
      stroke: "#0b2f55",
      strokeWidth: 4.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.4353472,38.569796 49.744957,7.0243946 50.467417,7.0691566 92.6132,38.463392",
    style: {
      fill: "none",
      stroke: "#0b2f55",
      strokeWidth: 4.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.222115,53.52382)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.222427,
    y: -19.357723,
    width: 25,
    height: 25,
    ry: 4.03929,
    style: {
      fill: "#00d7e5",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.1732559,
    y: -19.357723,
    width: 25,
    height: 25,
    ry: 4.03929,
    style: {
      fill: "#49cf00",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -37.222427,
    y: 9.3329611,
    width: 25,
    height: 25,
    ry: 4.03929,
    style: {
      fill: "#ffd900",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.1732559,
    y: 9.3329611,
    width: 25,
    height: 25,
    ry: 4.03929,
    style: {
      fill: "#0083f1",
      stroke: "none"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMyHomepageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my_homepage_icon.039da728aaa6e81dd7d98cae0d8dc88f.svg";